var map = {
	"./IconTemplates_-01.svg": 2886,
	"./IconTemplates_-02.svg": 2887,
	"./IconTemplates_-03.svg": 2888,
	"./IconTemplates_-04.svg": 2889,
	"./IconTemplates_-05.svg": 2890,
	"./IconTemplates_-06.svg": 2891,
	"./IconTemplates_-07.svg": 2892,
	"./IconTemplates_-08.svg": 2893,
	"./IconTemplates_-09.svg": 2894,
	"./IconTemplates_-10.svg": 2895,
	"./IconTemplates_-100.svg": 2896,
	"./IconTemplates_-101.jpg": 2897,
	"./IconTemplates_-11.svg": 2898,
	"./IconTemplates_-12.svg": 2899,
	"./IconTemplates_-13.svg": 2900,
	"./IconTemplates_-14.svg": 2901,
	"./IconTemplates_-15.svg": 2902,
	"./IconTemplates_-16.svg": 2903,
	"./IconTemplates_-17.svg": 2904,
	"./IconTemplates_-18.svg": 2905,
	"./IconTemplates_-19.svg": 2906,
	"./IconTemplates_-20.svg": 2907,
	"./IconTemplates_-21.svg": 2908,
	"./IconTemplates_-22.svg": 2909,
	"./IconTemplates_-23.svg": 2910,
	"./IconTemplates_-24.svg": 2911,
	"./IconTemplates_-25.svg": 2912,
	"./IconTemplates_-26.svg": 2913,
	"./IconTemplates_-27.svg": 2914,
	"./IconTemplates_-28.svg": 2915,
	"./IconTemplates_-29.svg": 2916,
	"./IconTemplates_-30.svg": 2917,
	"./IconTemplates_-31.svg": 2918,
	"./IconTemplates_-32.svg": 2919,
	"./IconTemplates_-33.svg": 2920,
	"./IconTemplates_-34.svg": 2921,
	"./IconTemplates_-35.svg": 2922,
	"./IconTemplates_-36.svg": 2923,
	"./IconTemplates_-37.svg": 2924,
	"./IconTemplates_-38.svg": 2925,
	"./IconTemplates_-39.svg": 2926,
	"./IconTemplates_-40.svg": 2927,
	"./IconTemplates_-41.svg": 2928,
	"./IconTemplates_-42.svg": 2929,
	"./IconTemplates_-43.svg": 2930,
	"./IconTemplates_-44.svg": 2931,
	"./IconTemplates_-45.svg": 2932,
	"./IconTemplates_-46.svg": 2933,
	"./IconTemplates_-47.svg": 2934,
	"./IconTemplates_-48.svg": 2935,
	"./IconTemplates_-49.svg": 2936,
	"./IconTemplates_-50.svg": 2937,
	"./IconTemplates_-51.svg": 2938,
	"./IconTemplates_-52.svg": 2939,
	"./IconTemplates_-53.svg": 2940,
	"./IconTemplates_-54.svg": 2941,
	"./IconTemplates_-55.svg": 2942,
	"./IconTemplates_-56.svg": 2943,
	"./IconTemplates_-57.svg": 2944,
	"./IconTemplates_-58.svg": 2945,
	"./IconTemplates_-59.svg": 2946,
	"./IconTemplates_-60.svg": 2947,
	"./IconTemplates_-61.svg": 2948,
	"./IconTemplates_-62.svg": 2949,
	"./IconTemplates_-63.svg": 2950,
	"./IconTemplates_-64.svg": 2951,
	"./IconTemplates_-65.svg": 2952,
	"./IconTemplates_-66.svg": 2953,
	"./IconTemplates_-67.svg": 2954,
	"./IconTemplates_-68.svg": 2955,
	"./IconTemplates_-69.svg": 2956,
	"./IconTemplates_-70.svg": 2957,
	"./IconTemplates_-71.svg": 2958,
	"./IconTemplates_-72.svg": 2959,
	"./IconTemplates_-73.svg": 2960,
	"./IconTemplates_-74.svg": 2961,
	"./IconTemplates_-75.svg": 2962,
	"./IconTemplates_-76.svg": 2963,
	"./IconTemplates_-77.svg": 2964,
	"./IconTemplates_-78.svg": 2965,
	"./IconTemplates_-79.svg": 2966,
	"./IconTemplates_-80.svg": 2967,
	"./IconTemplates_-81.svg": 2968,
	"./IconTemplates_-82.svg": 2969,
	"./IconTemplates_-83.svg": 2970,
	"./IconTemplates_-84.svg": 2971,
	"./IconTemplates_-85.svg": 2972,
	"./IconTemplates_-86.svg": 2973,
	"./IconTemplates_-87.svg": 2974,
	"./IconTemplates_-88.svg": 2975,
	"./IconTemplates_-89.svg": 2976,
	"./IconTemplates_-90.svg": 2977,
	"./IconTemplates_-91.svg": 2978,
	"./IconTemplates_-92.svg": 2979,
	"./IconTemplates_-93.svg": 2980,
	"./IconTemplates_-94.svg": 2981,
	"./IconTemplates_-95.svg": 2982,
	"./IconTemplates_-96.svg": 2983,
	"./IconTemplates_-97.svg": 2984,
	"./IconTemplates_-98.svg": 2985,
	"./IconTemplates_-99.svg": 2986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1417;